/**
 * Représente la configuration des dates
 */
export class DateConfig {

    // Options du date picker
    public static datePickerOptions: any = {
        sunHighlight: false,
        satHighlight: false
    };

    // Locale du date picker
    public static datePickerLocale: string = navigator.language ? navigator.language.substr(0, 2) : 'fr';
}
